<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-about"
    >
        <y-container>
            <y-about-quarkino :content="findPost('post1')" />
        </y-container>

        <div class="m-about__bg-part-one">
            <y-container>
                <y-about-album :content="findAlbum('post1', 'album')" />
                <y-about-our-experts
                    :fields="findPost('post1')?.custom"
                    :content="findAlbum('post1', 'album2')"
                />
            </y-container>
        </div>

        <y-container>
            <y-about-transform-business
                :fields="findPost('post1')?.custom"
                :content="findAlbum('post1', 'album3')"
            />
        </y-container>

        <y-container>
            <div class="mt-15">
                <y-our-client-say
                    :content="contentClientSay"
                    :clients-say="clientsSay"
                />
            </div>
        </y-container>

        <y-container>
            <div
                v-if="findPost('post1')?.custom"
                class="m-about__building-culture"
            >
                <h2>
                    {{ findPost('post1')?.custom.field5 }}
                </h2>
                <p>
                    {{ findPost('post1')?.custom.field6 }}
                </p>
            </div>
        </y-container>

        <div class="m-about__bg-part-two">
            <y-container>
                <y-about-get-in-touch :content="findPost('post2')" />
                <y-about-take-next-step
                    title-tag="h4"
                    :content="findPost('post2')"
                />
            </y-container>
        </div>
    </div>
</template>

<script>

    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Components
    import YAboutQuarkino from '@/modules/about/components/AboutQuarkino/Index';
    import YAboutAlbum from '@/modules/about/components/Albums/Index';
    import YAboutOurExperts from '@/modules/about/components/OurExperts/Index';
    import YAboutTransformBusiness from '@/modules/about/components/TransformingBusinesses/Index';
    import YOurClientSay from '@/components/OurClientsSay/Index';
    import YAboutGetInTouch from '@/modules/about/components/GetInTouch/Index';
    import YAboutTakeNextStep from '@/modules/about/components/TakeNextStep/Index';

    export default {

        name: 'AboutPage',

        components: {
            YAboutQuarkino,
            YAboutAlbum,
            YAboutOurExperts,
            YAboutTransformBusiness,
            YOurClientSay,
            YAboutGetInTouch,
            YAboutTakeNextStep,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                about           : null,
                clientsSay      : null,
                contentClientSay: {},
                heroContent     : '',
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            /**
             * Find post
             *
             * @param {string} slug
             * @returns {*}
             */
            findPost(slug) {
                return this.about.find(((item) => item.slug === slug));
            },

            /**
             * Find album
             *
             * @param {string} slug
             * @param {string} key
             * @returns {*}
             */
            findAlbum(slug, key) {
                const list = this.about.find(((item) => item.slug === slug));
                const albums = list.albums.filter(((item) => item.group === key));
                return { albums };
            },

            /**
             * Fetch home data
             *
             * @returns {Promise}
             */
            fetch() {
                const about = this.$services.Content.postList({
                    type     : 'aboutus',
                    including: ['title', 'synopsis', 'image', 'text', 'custom', 'slug', 'albums', 'title2', 'seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const clientsSay = this.$services.Content.postList({
                    type     : 'testimonials',
                    tagging  : 'about-us',
                    including: ['title', 'title2', 'header_image', 'image', 'synopsis'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const contentClientSay = this.$services.Content.postSingle({
                    type     : 'home-page',
                    slug     : 'home6',
                    including: ['image', 'text', 'title'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([about, clientsSay, contentClientSay]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.about = responses[0].data.results;
                        this.heroContent = this.findPost('post1');
                    }
                    if (this.handleReq(responses, 1)) {
                        this.clientsSay = responses[1].data.results;
                    }
                    if (this.handleReq(responses, 2)) {
                        this.contentClientSay = responses[2].data.results;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };
</script>

<style lang="scss" src="../scss/about.scss" />

